import axios from 'axios'

export default {
    getProfile(email) {
        return axios.get('/api/profiles', { params: { email: email } })
            .then(response => {
                return response.data
            })
    },
    getProfileFromSession(session) {
        return axios.get('/api/profiles/fromsession', { params: { session: session } })
            .then(response => {
                return response.data
            })
    }
}